import {ActionIcon, Tooltip} from "@mantine/core";
import {RenderableDocument, DibJsonNode} from "../../types";
import {extractText} from "../../contentUtils";
import {usePanel} from "../../panel/PanelContext";
import ArrowsMaximize from "../../../../assets/arrows-maximize.svg?react";

export const ExmarkLink = ({
    node,
    map,
}: {
    node: DibJsonNode;
    map: RenderableDocument;
}) => {
    const {openPanel} = usePanel();

    const attrs = node.element?.attributes;
    const id = attrs?.["data-id"] ?? "";
    const title = attrs?.title || extractText(map.elements, id);
    const segmentId = attrs?.["data-segment"] ?? "preview";
    const resourceId = map.topicId;

    const handleClick = () => {
        openPanel({
            label: title || "Expand",
            fetchType: "documentParts",
            params: {resourceId, segmentId, id},
        });
    };

    return (
        <Tooltip label={`Utvid ${title}`}>
            <ActionIcon
                variant="transparent"
                size="sm"
                onClick={handleClick}
                aria-label={`Utvid ${title}`}
            >
                <ArrowsMaximize width={14} height={14} />
            </ActionIcon>
        </Tooltip>
    );
};
